import React from "react";
import { Box, Typography, Button } from "@mui/material";

const DesignMenu = ({
  toggleDrawer,
  editItem,
  headerItemData,
  handleApi,
  isMobile,
}) => {
  const designList = [
    { key: "textColor", name: "Text - Default Color" },
    { key: "textHoverColor", name: "Text - Hover Color" },
    { key: "textActiveColor", name: "Text - Active Color" },
    { key: "buttonColor", name: "Button - Default Color" },
    { key: "buttonHoverColor", name: "Button - Hover Color" },
    { key: "buttonActiveColor", name: "Button - Active Color" },
    { key: "borderColor", name: "Border - Default Color" },
    { key: "borderHoverColor", name: "Border - Hover Color" },
    { key: "borderActiveColor", name: "Border - Active Color" },
    { key: "buttonTextColor", name: "Popup Button Text - Default Color" },
    { key: "buttonTextHoverColor", name: "Popup Button Text - Hover Color" },
    { key: "buttonTextActiveColor", name: "Popup Button Text - Active Color" },
    {
      key: "popupButtonColor",
      name: "Popup Button Background - Default Color",
    },
    {
      key: "popupButtonHoverColor",
      name: "Popup Button Background - Hover Color",
    },
    {
      key: "popupButtonActiveColor",
      name: "Popup Button Background - Active Color",
    },
    { key: "buttonBorderColor", name: "Popup Button Border - Default Color" },
    {
      key: "buttonBorderHoverColor",
      name: "Popup Button Border - Hover Color",
    },
    {
      key: "buttonBorderActiveColor",
      name: "Popup Button Border - Active Color",
    },
    { key: "borderColor", name: "Popup Border - Color" },
    { key: "backgroundColor", name: "Popup Background - Color" },
  ];

  let headerType = isMobile ? "mobileTopbar" : "customTopbar";

  return (
    <Box
      sx={{
        borderRadius: "5px",
        width: "100%",
        height: "100vh",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "#fff",
        overflowY: "scroll",
        "&::-webkit-scrollbar": {
          width: "6px",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "#f4f4f4",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#888",
          borderRadius: "10px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#555",
        },
      }}
    >
      <Box
        sx={{
          width: "100%",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#333",
            color: "#fff",
            padding: "5px",
            marginBottom: "16px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", fontSize: "16px" }}
          >
            Header Item {editItem.index + 1} - Design
          </Typography>
          <Button
            variant="text"
            sx={{ fontWeight: "bold", color: "#fff" }}
            onClick={() => {
              toggleDrawer(true, editItem.index, "menu");
            }}
          >
            Back
          </Button>
        </Box>

        {designList.map((item, index) => {
          return index === 9 ? (
            <>
              <Box
                key={item.key + Date.now()}
                sx={{
                  height: "50px",
                  display: "flex",
                  alignItems: "center",
                  padding: "0 5px",
                  borderBottom: "2px solid #B5B5B5",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    columnGap: "10px",
                  }}
                >
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    Popup Settings
                  </Typography>
                </Box>
              </Box>
              <Box
                key={item.key}
                sx={{
                  height: "50px",
                  display: "flex",
                  alignItems: "center",
                  padding: "0 5px",
                  borderBottom: "2px solid #B5B5B5",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    columnGap: "10px",
                  }}
                >
                  <Typography variant="subtitle1">{item.name}</Typography>

                  <Button
                    variant="outlined"
                    onClick={() =>
                      toggleDrawer(
                        editItem.open,
                        editItem.index,
                        "picker",
                        item.key,
                        editItem.item
                      )
                    }
                    sx={{
                      background:
                        headerItemData.customHeader[headerType].links[
                          editItem.index
                        ][editItem.item][item.key],
                      width: "40px",
                      height: "40px",
                      minWidth: "40px",
                      border: "1px solid #ccc",
                      "&:hover": {
                        background:
                          headerItemData.customHeader[headerType].links[
                            editItem.index
                          ][editItem.item][item.key], // Keeps the same background color
                      },
                    }}
                  ></Button>
                </Box>
              </Box>
            </>
          ) : (
            <Box
              key={item.key}
              sx={{
                height: "50px",
                display: "flex",
                alignItems: "center",
                padding: "0 5px",
                borderBottom: "2px solid #B5B5B5",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  columnGap: "10px",
                }}
              >
                <Typography variant="subtitle1">{item.name}</Typography>

                <Button
                  variant="outlined"
                  onClick={() =>
                    toggleDrawer(
                      editItem.open,
                      editItem.index,
                      "picker",
                      item.key,
                      editItem.item
                    )
                  }
                  sx={{
                    background:
                      headerItemData.customHeader[headerType].links[
                        editItem.index
                      ][editItem.item][item.key],
                    width: "40px",
                    height: "40px",
                    minWidth: "40px",
                    border: "1px solid #ccc",
                    "&:hover": {
                      background:
                        headerItemData.customHeader[headerType].links[
                          editItem.index
                        ][editItem.item][item.key], // Keeps the same background color
                    },
                  }}
                ></Button>
              </Box>
            </Box>
          );
        })}
      </Box>
      <Button
        variant="contained"
        color="success"
        fullWidth
        sx={{
          fontSize: "12px",
          padding: "6px",
          width: "90%",
          borderRadius: "50px",
          margin: "15px 0",
        }}
        onClick={handleApi}
      >
        Save
      </Button>
    </Box>
  );
};

export default DesignMenu;
